<template>
  <v-content
    class="ma-0 pa-0"
  >
    <v-container
      class="my-0"
      fluid
      v-if="isReady"
    >
      <pageTitle
        v-if="isShowTitle"
      >
        Activity
      </pageTitle>
      <v-tabs
        v-model="tab"
        grow
        class="posts-tab"
      >
        <v-tab class="ml-0">Shots Others Liked</v-tab>
        <v-tab>Shots You Bookmarked</v-tab>
      </v-tabs>
      <blockContent
        class="mx-0"
      >
        <v-tabs-items
          v-model="tab"
          touchless
        >
          <v-tab-item>
            <div
              class="d-flex pl-2"
              style="width:100%;overflow-x:scroll"
            >
              <!-- all -->
              <div
                v-if="myShots.length > 0"
                class="mt-1 mb-4 ml-2 my-shot-img"
                @click="clickAll"
               >
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="36" cy="36" r="36" :fill="isAll ? '#9D95F7' : '#3A2BEE'"/>
                  <path d="M32.155 40.691C32.223 40.8383 32.257 40.9857 32.257 41.133C32.257 41.3937 32.1493 41.6147 31.934 41.796C31.73 41.9773 31.492 42.068 31.22 42.068C31.0387 42.068 30.8687 42.0227 30.71 41.932C30.5513 41.83 30.4267 41.677 30.336 41.473L29.316 39.195H23.332L22.312 41.473C22.2213 41.677 22.0967 41.83 21.938 41.932C21.7793 42.0227 21.6037 42.068 21.411 42.068C21.1503 42.068 20.9123 41.9773 20.697 41.796C20.4817 41.6147 20.374 41.3937 20.374 41.133C20.374 40.9857 20.408 40.8383 20.476 40.691L25.168 30.61C25.27 30.3833 25.423 30.2133 25.627 30.1C25.8423 29.9753 26.069 29.913 26.307 29.913C26.545 29.913 26.766 29.9753 26.97 30.1C27.1853 30.2133 27.344 30.3833 27.446 30.61L32.155 40.691ZM24.08 37.495H28.568L26.324 32.446L24.08 37.495ZM34.9462 42C34.6175 42 34.3625 41.9093 34.1812 41.728C33.9999 41.5467 33.9092 41.2973 33.9092 40.98V31.018C33.9092 30.6893 34.0055 30.4287 34.1982 30.236C34.4022 30.032 34.6685 29.93 34.9972 29.93C35.3372 29.93 35.6035 30.032 35.7962 30.236C36.0002 30.4287 36.1022 30.6893 36.1022 31.018V40.198H40.8792C41.5592 40.198 41.8992 40.4983 41.8992 41.099C41.8992 41.6997 41.5592 42 40.8792 42H34.9462ZM44.3759 42C44.0472 42 43.7922 41.9093 43.6109 41.728C43.4295 41.5467 43.3389 41.2973 43.3389 40.98V31.018C43.3389 30.6893 43.4352 30.4287 43.6279 30.236C43.8319 30.032 44.0982 29.93 44.4269 29.93C44.7669 29.93 45.0332 30.032 45.2259 30.236C45.4299 30.4287 45.5319 30.6893 45.5319 31.018V40.198H50.3089C50.9889 40.198 51.3289 40.4983 51.3289 41.099C51.3289 41.6997 50.9889 42 50.3089 42H44.3759Z" fill="white"/>
                </svg>
              </div>
              <!-- shots -->
              <v-img
                v-for="item in myShots"
                :key="item.pid"
                :src="item.photoUrl"
                :width="72"
                :max-width="72"
                :height="72"
                style="border-radius:8px"
                class="mt-1 mb-4 ml-2 my-shot-img"
                :class="item.selected ? 'selected' : ''"
                @click="clickMyShotImg(item)"
              ></v-img>
              <!-- add shots -->
              <div
                class="mt-1 mb-4 ml-2 mr-4 pr-4 my-shot-img"
                @click="postNew()"
              >
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="71" height="71" rx="7.5" fill="#FAFAFA" stroke="#C5C3C3"/>
                  <path d="M42.692 37.3784H37.3823V42.6881C37.3823 43.2722 36.9044 43.7501 36.3203 43.7501C35.7363 43.7501 35.2584 43.2722 35.2584 42.6881V37.3784H29.9487C29.3646 37.3784 28.8867 36.9005 28.8867 36.3164C28.8867 35.7324 29.3646 35.2545 29.9487 35.2545H35.2584V29.9448C35.2584 29.3607 35.7363 28.8828 36.3203 28.8828C36.9044 28.8828 37.3823 29.3607 37.3823 29.9448V35.2545H42.692C43.2761 35.2545 43.754 35.7324 43.754 36.3164C43.754 36.9005 43.2761 37.3784 42.692 37.3784Z" fill="#929191"/>
                </svg>
              </div>
            </div>
            <GmapMap
              ref="map"
              :center="map.center"
              :zoom="map.zoom"
              :options="mapOptions"
              style="width:100%;height:300px"
              @click="info.isShow = false"
            >
              <gmapInfoWindow
                ref="infoWindow"
                :options="info.options"
                :position="info.position"
                :opened="info.isShow"
                @closeclick="info.isShow = false"
              >
                <div
                  class="info-window"
                >
                  <div class="nickname">
                    {{ profile.nickname }}&nbsp;&nbsp;<span class="generation" v-text="profile.generation"></span>
                  </div>
                  <div class="emoji">
                    {{ profile.passionEmoji }}<br />
                  </div>
                  <div
                    class="see-profile"
                  >
                    <span
                      @click="showProfile(profile.uid)"
                    >
                      See Profile
                    </span>
                  </div>
                </div>
              </gmapInfoWindow>
              <gmapMarker
                :key="index"
                v-for="(item, index) in markerList"
                :position="item.position"
                :clickable="true"
                :name="item.nickname"
                :icon="item.icon"
                @click="clickMarker(item)"
              />
            </GmapMap>
            <div
              class="area-title"
            >
              {{ selectedArea.city }} {{ selectedArea.region }}
            </div>
            <div
              class="who"
              v-for="item in users"
              :key="item.uid"
            >
              <img
                :src="item.photoUrl"
                class="photo"
                @click="showProfile(item.uid)"
              >
              <div
                class="right"
              >
                <div
                  class="name"
                >
                  {{ item.nickname }}&nbsp;&nbsp;<span class="generation" v-text="item.generation"></span>
                </div>
                <div
                  class="icon"
                >
                  {{ item.passionEmoji }}<br />
                </div>
                <div
                  class="see-profile"
                  @click="showProfile(item.uid)"
                >
                  See Profile
                </div>
              </div>
            </div>
          </v-tab-item>

          <!-- Bookmark -->
          <v-tab-item>
            <template
              v-for="items in bookmarks"
            >
              <blockTitle
                :key="`t${items.likeName}`"
              >
                {{ items.likeName }}
              </blockTitle>
              <blockContent
                :key="`c${items.likeName}`"
              >
                <v-row
                  class="ma-0"
                  :key="'l' + items.likeName"
                >
                  <likeCol
                    v-for="item in items.list"
                    :key="item.pid"
                    :item="item"
                    :showLikeName="false"
                    @click="showLikeDetail(item.pid)"
                  ></likeCol>
                </v-row>
              </blockContent>
            </template>
          </v-tab-item>
        </v-tabs-items>
      </blockContent>
    </v-container>

    <messageBox
      ref="msgBox"
    ></messageBox>

    <bottomNavigation
      v-if="$route.name !== 'RNActivity'"
      activeNav="Activity"
    ></bottomNavigation>
  </v-content>
</template>

<script>
import service from '@/plugins/service'
import BottomNavigation from '@/components/Like/BottomNavigation'
import PageTitle from '@/components/Like/PageTitle'
import BlockTitle from '@/components/Like/BlockTitle'
import BlockContent from '@/components/Like/BlockContent'
import GmapMarker from 'vue2-google-maps/src/components/marker'
import GmapInfoWindow from 'vue2-google-maps/src/components/infoWindow'
import MessageBox from '@/components/MessageBox'
import LikeCol from '@/components/Like/LikeCol'

export default {
  components: {
    BottomNavigation,
    PageTitle,
    BlockTitle,
    BlockContent,
    GmapMarker,
    GmapInfoWindow,
    MessageBox,
    LikeCol,
  },
  data: () => ({
    isReady: false,
    isShowTitle: true,
    isAll: true,
    fromRN: false,
    tab: null,
    user: {},
    users: [],
    markerList: [],
    bookmarks: [],
    bookmarkMarkers: [],
    profile: {
      uid: '',
      photoUrl: '',
      nickname: '',
      generation: '',
      passionEmoji: '',
    },
    selectedArea: {
      region: '',
      city: '',
    },
    map: {
      zoom: 0.57,
      center: {lat: 35.71, lng: 139.72},
    },
    info: {
      isShow: false,
      options: {
        pixelOffset: {
          width: 0,
          height: -35
        },
      },
      position: {},
      nickname: '',
      generation: '',
      emoji: '',
      uid: '',
    },
    mapOptions: {
      mapTypeControl: false,
      gestureHandling: 'greedy',
      fullscreenControl: false,
      streetViewControl: false,
      maxZoom: 10,
    },
    otherLiked: {},
    myShots: [],
  }),
  async mounted() {
    // ログインチェック
    try {
      this.user = await service.authCheck()
    } catch (e) {
      if (this.$route.name === 'RNActivity') {
        // React Nativeから呼ばれている場合は引数をUIDとして扱う
        this.user.uid = this.$route.params.uid
        this.fromRN = true
      } else {
        // React Native出ない場合はログインを促す
        this.$router.replace('/signIn/activity')
        return
      }
    }
    this.isReady = true
    // 自身のShotsの一覧
    service.getUserLikes(this.user.uid).then(myshots => {
      if (myshots.res.length < 1) {
        this.$refs.msgBox.show(
          'Tips✨',
          `It looks like you haven’t added your passion shots yet.<br />Let’s collect likes across the world by sharing your passion shot🧡`,
          'OK',
        )
        return
      }
      myshots.res.forEach(item => {
        item.selected = true
        this.myShots.push(item)
      })
    })
    // 地図にアイコンを置く
    this.refreshMarker()
    // Bookmarkの一覧を取得
    service.getBookmarks(this.user.uid).then(json => {
      const list = []
      let oldLikeName = ''
      if (Array.isArray(json.res)) {
        json.res.forEach(item => {
          if (oldLikeName != item.likeName) {
            list.push({
              likeName: item.likeName,
              icon: item.icon,
              list: [],
            })
          }
          oldLikeName = item.likeName
          list[list.length - 1].list.push(item)
        })
        list.forEach(item => this.bookmarks.push(item))
      }
    })
  },
  methods: {
    clickMarker(item) {
      this.isShowTitle = false
      const currentZoom = this.$refs.map.$mapObject.zoom
      let newZoom = currentZoom + 3
      if (currentZoom < this.mapOptions.maxZoom) {
        if (newZoom > 10) {
          newZoom = 10
        }
        this.map.center.lat = item.position.lat
        this.map.center.lng = item.position.lng
        // 地図の手動zoomでvue2-google-mapsがzoom制御を失うので
        // Google Maps APIを直接操作する。
        // this.map.zoom = newZoom
        this.$refs.map.$mapObject.setZoom(newZoom)
      }
      if (newZoom >= this.mapOptions.maxZoom) {
        if (item.cnt == 1) {
          this.profile.uid = item.uid
          this.profile.nickname = item.nickname
          this.profile.photoUrl = item.photoUrl
          this.profile.generation = item.generation
          this.profile.passionEmoji = item.passionEmoji
          this.users.splice(0)
          this.users.push(this.profile)
          this.info.position = item.position
          this.info.isShow = true
          // 既読
          service.checkLike(this.user.uid, item.uid)
        } else {
          this.profile = {}
          this.info.isShow = false
          const pidList = []
          this.myShots.forEach(item => {
            if (item.selected) {
              pidList.push(item.pid)
            }
          })
          const users = this.users
          service.getOtherLikedByArea(
            item.countryCode,
            item.regionCode,
            item.cityId,
            pidList
          ).then(res => {
            users.splice(0)
            res.forEach(item => {
              // 既読
              service.checkLike(this.user.uid, item.uid)
              users.push(item)
            })
          })
        }
        this.selectedArea.region = item.region.replace(/prefecture/i, '')
        this.selectedArea.city = item.city + ','
      }
    },
    clickAll(item) {
      this.isShowTitle = false
      this.info.isShow = false
      let count = 0
      this.myShots.forEach(shot => {
        count += shot.selected ? 1 : 0
      })
      this.myShots.forEach(shot => {
        shot.selected = count != this.myShots.length
      })
      if (count == this.myShots.length) {
        this.isAll = false
        this.markerList.splice(0)
      } else {
        this.isAll = true
        this.refreshMarker()
      }
    },
    clickMyShotImg(item) {
      this.isShowTitle = false
      this.info.isShow = false
      this.myShots.forEach(shot => {
        shot.selected = shot.pid == item.pid
      })
      this.isAll = false
      this.refreshMarker()
    },
    refreshMarker() {
      const pidList = []
      this.myShots.forEach(item => {
        if (item.selected) {
          pidList.push(item.pid)
        }
      })
      service.getOtherLiked(this.user.uid, pidList).then(res => {
        this.markerList.splice(0)
        res.forEach(user => {
          if (user.cnt == 1) {
            if (user.isCheck == '0') {
              user.icon = `/thumbnails/s/00.php?name=${user.uid}`
            } else {
              user.icon = `/thumbnails/s/${user.uid}.png`
            }
          } else {
            if (user.isCheck == '0') {
              user.icon = '/thumbnails/s/00.php?name=00'
            } else {
              user.icon = '/thumbnails/s/00.png'
            }
          }
          user.position = {
            lat: parseFloat(user.lat),
            lng: parseFloat(user.lng),
          }
          this.markerList.push(user)
        })
      });
    },
    showProfile(uid) {
      if (this.fromRN) {
        window.ReactNativeWebView.postMessage(`Profile:${uid}`)
      } else {
        this.$router.push(`/profile/${uid}`)
      }
    },
    showLikeDetail(pid) {
      if (this.fromRN) {
        window.ReactNativeWebView.postMessage(`LikeDetail:${pid}`)
      } else {
        this.$router.push(`/likeDetail/${pid}`)
      }
    },
    postNew() {
      if (this.fromRN) {
        window.ReactNativeWebView.postMessage('PostNew:')
      } else {
        this.$router.push('/post/new')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.posts-tab .v-tab
  font-size 16px
  text-transform none

div.info-window
  font-size 17px
  width 200px
  height 68px
  div.nickname
    height 25px
    overflow hidden
    text-overflow ellipsis
    font-style normal
    font-weight bold
    line-height 23px
    span.generation
      font-size 16px
      color #6F6B69
      font-weight normal
  div.emoji
    height 26px
    line-height 24px
    overflow hidden
    text-overflow ellipsis
  div.see-profile
    height 17px
    text-align right
    line-height 15px
    span
      font-size 12px
      color #3DB3E4

.my-shot-img
  border 0 solid #ff5500
  cursor pointer

.selected
  border-width 4px

div.area-title
  margin 12px 16px 20px 16px
  font-size 20px
  line-height 22px

div.who
  position relative
  min-height 88px
  margin 16px 16px
  img.photo
    position absolute
    width 88px
    height 88px
    border-radius 43px
    cursor pointer
  div.right
    padding 0 0 0 102px
    div.name
      min-height 24px
      font-size 17px !important
      font-style normal
      font-weight bold
      line-height 24px
      span.generation
        font-size 16px
        color #6F6B69
        font-weight normal
    div.icon
      min-height 25px
      font-size 17px !important
      font-style normal
      font-weight bold
      line-height 24px
    div.see-profile
      /* margin-top 17px */
      line-height 24px
      height 24px
      font-size 17px !important
      color #3DB3E4
</style>
